package com.mgacreative.hotel.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BlacklistedGuest(
    val id: String = "",
    @SerialName("tenant_id") val tenantId: String = "",
    @SerialName("full_name") val fullName: String,
    @SerialName("identity_no") val identityNo: String = "",
    val reason: String = "",
    @SerialName("created_at") val createdAt: String = ""
)
